import { useEffect, useContext, useState } from "react";

import { Image, Text, Link, VStack, Button, CloseIcon } from "native-base";
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { getDocument } from "..//utils/firebase/getDoc";
import { filterDataByPage } from "..//utils";
import StyledButton from "../components/Button";
import { COLLECTION, PAGETYPE } from "../constants";
import {dispatchAnalyticsEvent,dispatchAnalyticsPageView} from '../utils'
import { AppContext } from '../context';
import {ORG_ID} from '../constants/index'
function Return() {
  const navigate = useNavigate();
  const [getPageData, setPageData] = useState(null);
  const [getTheme, setTheme] = useState(null);
  const { getData,getParams} = useContext(AppContext);

  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const Acv = require("../images/amarezza/Acv.png");
  const currentURL = window.location.href;
  // Use the URL constructor to parse the URL
  const urlObj = new URL(currentURL);

  // Extract the "la-makanerie" value from the pathname
  const pathnameParts = urlObj.pathname.split("/");

  
  const warrantyInfo = {
    purchaseDate: "16 MARCH 2023",
    warrantyValidUntil: "15 MARCH 2038",
    returnsPolicy: "This garment had a 30 day return and exchange time period. Unfortunately, that date has passed and you can no longer return or exchange it."
  };
  const style = queryParams.get("style");
  const orgId = queryParams.get("orgId");

  useEffect(() => {
    dispatchAnalyticsPageView(location.pathname,PAGETYPE.return)
    setPageData(filterDataByPage(getData, getParams.styleId, getParams.lang, PAGETYPE.warranty));
    // setTheme(filterDataByPage(getData, getParams.styleId, getParams.lang));
  }, [getData]);

  
  return (
    <>
      {getPageData && (
        <>
          <VStack alignItems="flex-start" space={0} px={"4"} paddingTop={"4"}>
            <Button onPress={() => navigate(-1)} variant={"unstyled"}>
              <CloseIcon color={
                getParams.style==='acqua'? '#B03D01' :
                getParams.style==='amarezza'?
                '#DCA459D0' : 
                getPageData?.theme?.color?.primary} size={"4"} />
            </Button>
          </VStack>
          <VStack alignItems={"center"} marginBottom={"8"}>
            <Text
                color={ style ==='jamtland' ?"#1341B6": getPageData?.theme?.color?.primary}
                fontSize={getPageData.theme.fontSize.xl}
              fontFamily={getPageData.theme.fontFamily.secondary}
              letterSpacing={"0.46px"}
              // lineHeight={getPageData.title.styleSheet.lineHeight}
              // textAlign={getPageData.title.styleSheet.textAlign}
            >
              {getPageData.data.title}
            </Text>
          </VStack>

          <VStack alignItems="flex-start" space={2} px={"4"}>
          {
            pathnameParts[1] ==='a-new-sweden' ? 
            <><Text
                  fontWeight={getPageData.theme.fontWeight.regular}
                  color={getPageData?.theme?.color?.primary}
                  fontSize={getPageData.theme.fontSize.small}
                  fontFamily={getPageData.theme.fontFamily.subTitle}
                  textTransform={"uppercase"}
                >
                  {getPageData.data.purchaseDate}
                </Text><Text
                  fontWeight={getPageData.theme.fontWeight.regular}
                  color={getPageData?.theme?.color?.primary}
                  fontSize={getPageData.theme.fontSize.small}
                  fontFamily={getPageData.theme.fontFamily.subTitle}
                  textTransform={"uppercase"}
                >
                    {getPageData.data.expireDate}
                  </Text></>
            : 
            <>
            <Text
                   color={style === 'acqua'? "#882517" : style ==='amarezza' ? '#882517' : getPageData?.theme?.color?.primary}
                   py={ pathnameParts[1] === 'a-new-sweden' ? 2 : 0}
                   fontSize={getPageData.theme.fontSize.buttonText}
                   fontFamily={getPageData.theme.fontFamily.primary}
                   textTransform={"uppercase"}
                >
                    {getPageData.data.secondaryTitle}
                  </Text>
                  </>
}
            </VStack>

            <VStack alignItems="flex-start" space={4} px={"4"} marginTop={ pathnameParts[1] === 'a-new-sweden' ?'24px':'0px'}>
              
            <Text
             color={ getPageData?.theme?.color?.primary}
             fontSize={getPageData.theme.fontSize.small}
           fontFamily={getPageData.theme.fontFamily.primary}
              fontWeight={getPageData.theme.fontFamily.light}
            >
              {getPageData.data.mainDescriptionSection.section_A}
            </Text>
            
            <Text
              color={ getPageData?.theme?.color?.primary}
              fontSize={getPageData.theme.fontSize.small}
            fontFamily={getPageData.theme.fontFamily.primary}
            fontWeight={getPageData.theme.fontFamily.light}

            >
               {pathnameParts[1] === 'la-makanerie' ? (
    <a href="https://www.la-makanerie.com/conditions-g%C3%A9n%C3%A9rales-de-ventes" target="_blank" rel="noopener noreferrer"
      style={{ color: 'black', textDecoration: 'none' }} 
    >
      {getPageData.data.mainDescriptionSection.section_B}
    </a>
  ) : (
    getPageData.data.mainDescriptionSection.section_B
  )}
        { pathnameParts[1] === 'a-new-sweden' &&      <Text
      color={ getPageData?.theme?.color?.primary}
    fontSize={getPageData.theme.fontSize.small}
    fontFamily={getPageData.theme.fontFamily.subTitle}
    fontWeight={getPageData.theme.fontFamily.regular}
  >
    help@anewsweden.com
  </Text>
      }
            </Text>
            {
  pathnameParts[1]==='a-new-sweden' ?
  <>
   <Text
      color={getPageData?.theme?.color?.primary}
      py={2}
      fontSize={getPageData.theme.fontSize.buttonText}
      fontFamily={getPageData.theme.fontFamily.subTitle}
      fontWeight={getPageData.theme.fontWeight.regular}
      textTransform={"uppercase"}

    >
      {getPageData.data.ternaryTitle}
    </Text>
    </> :
    <Text
      color={style === 'acqua'? "#882517" : style ==='amarezza' ? '#882517' : getPageData?.theme?.color?.primary}
      py={1}
      fontSize={getPageData.theme.fontSize.buttonText}
      fontFamily={getPageData.theme.fontFamily.primary}
      textTransform={"uppercase"}
      mb={1}
    >
      {getPageData.data.ternaryTitle}
    </Text>
}
            <Text
              color={ getPageData?.theme?.color?.primary}
              fontFamily={getPageData.theme.fontFamily.primary}  
              fontWeight={getPageData.theme.fontFamily.light}
              fontSize={getPageData.theme.fontSize.small}
              mt={-5}
              >
              {getPageData.data.descriptionTernary}
            </Text>
            {
             pathnameParts[1] === 'la-makanerie' && 
            <Link
                  href="https://la-makanerie.com/en/policies/refund-policy"
                  width={"full"}
                >
                  <StyledButton
                    text={getPageData.data.actionButton}
                    backgroundColor={style ==='amarezza'? '#DCA459' : getTheme?.theme?.color?.primary}
                    textColor="#FFFFFF"
                    borderColor="transparent"
                    width="100%"
                    height="54px"
                    hoverBackgroundColor="#FFFFFF"
                    hoverTextColor={style ==='amarezza'? '#DCA459': getTheme?.theme?.color?.primary}
                    hoverBorderColor={style ==='amarezza'? '#DCA459': getTheme?.theme?.color?.primary} />
                </Link>
              }
          </VStack>

         <VStack alignItems={"center"} marginTop={'24px'}>
            <Image
              source={{
                uri: style === "amarezza" ? Acv : getPageData.data.image,
              }}
              alt="Alternate Text"
              size="xl"
              width="full"
              height="auto"
              minHeight={"378px"}
            />
          </VStack>
        </>
      )}
    </>
  );
}

export default Return;
